import { render } from "./Notifier.vue?vue&type=template&id=60b9adbc&scoped=true"
import script from "./Notifier.vue?vue&type=script&lang=js"
export * from "./Notifier.vue?vue&type=script&lang=js"

import "./Notifier.vue?vue&type=style&index=0&id=60b9adbc&scoped=true&lang=scss"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b9adbc"]])

export default __exports__